<template>
  <div class="card yellow">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
        <div class="col black">
          <h3>
            <i class="fas fa-phone-alt"></i> Call Date Report
          </h3>
        </div>
        <!-- Default checked -->
        <div class="text-right">
           <label class="custom-toggle">
            <input v-model="callBuyOrSell" type="checkbox" @change="setCallReportData" id="callCheck" />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div class="chart">
        <div class="row">
          <div class="col-md-5">
            <img src="../../assets/img/ChartIcon.png" alt class="img-fluid" />
          </div>
          <div class="col-md-7">
            <div class="call">
              <span>{{callDataFirstFive.count}} CUSIP</span>
              <span>CALL DATE YEAR : {{callDataFirstFive.label}}</span>
              <span class="icon">
                <i class="fas fa-chart-line"></i>
              </span>
            </div>
            <div class="call">
              <span>{{callDataNextFive.count}} CUSIP</span>
              <span>CALL DATE YEAR : {{callDataNextFive.label}}</span>
              <span class="icon">
                <i class="fas fa-chart-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <a href @click="showPopup" class="view-more">
        View More
        <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
      </a>
          <div
      class="modal fade bd-example-modal-xl"
      id="callViewMore"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Call Date Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="col-lg-9 col-5 tradeDate">
              </div>
              <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input type="checkbox" v-model="popupCallBuyOrSell" @change="setPopupCallReportData">
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
            </div>
            <div class="graph">
              <canvas id="popupCallChart"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
export default {
     props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getCallReportData();
      },
      deep: true
    }
  },
  data() {
    return {
        accessToken: null,
        callBuyOrSell: false,
        callChartDataOptions :  chartConstants.callChartDefault,
        callChartData : "",
        callDataFirstFive : {},
        callDataNextFive : {},
        popupCallChartData : {},
        popupCallBuyOrSell : false,
        myChart :null
        
    }
  },
  methods: {
    getCallReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/call-date?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.callChartData = result.data.data;
          this.setCallReportData();
        });
    },
    getPopupCallReportData(){
        const auth = { headers: { authorization: this.accessToken } };
        this.$http
            .get(
            config.baseUrl +
                "/report/call-date?fromDate=" +
                this.fromdate +
                "&toDate=" +
                this.todate +
                "&dashboard=false",
            auth
            )
            .then(result => {
            this.popupCallChartData = result.data.data;
            this.setPopupCallReportData();
            });

    },
    setCallReportData(){
        this.callDataFirstFive = this.callBuyOrSell ? this.callChartData.sellFirstFive : this.callChartData.buyFirstFive;
        this.callDataNextFive  = this.callBuyOrSell ? this.callChartData.sellNextFive : this.callChartData.buyNextFive;

    },
    setPopupCallReportData(){
      this.callChartDataOptions.data.labels = this.popupCallBuyOrSell ?  this.popupCallChartData.sellsLabels : this.popupCallChartData.buysLabels;
      this.callChartDataOptions.data.datasets[0].data = this.popupCallBuyOrSell
        ? this.popupCallChartData.sells
        : this.popupCallChartData.buys;

      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("popupCallChart");
      this.myChart = new window.Chart(ctx, {
        type: this.callChartDataOptions.type,
        data: this.callChartDataOptions.data,
        options: this.callChartDataOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      this.getPopupCallReportData();
      window.$("#callViewMore").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getCallReportData();
      }
    });
  }
    
}
</script>